var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    className: "twitter-svg",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.125 7.49999L25.3125 7.96874L27.1875 5.62499L23.9062 6.56249C19.6875 1.87499 13.125 7.03124 15 11.25C7.5 11.25 3.75 5.62499 3.75 5.62499C3.75 5.62499 0.9375 9.84374 5.625 13.125L2.8125 12.1875C2.8125 15 4.6875 16.875 7.96875 17.8125H4.6875C6.5625 21.5625 9.84375 21.5625 9.84375 21.5625C9.84375 21.5625 7.03125 23.9062 1.875 23.9062C17.3438 31.4062 26.7188 17.3437 25.3125 9.84374L28.125 7.49999Z",
    fill: "#EEEEEE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2aaf8b3173403248731d2b6111c7e46d.svg";
export { ForwardRef as ReactComponent };